import {
  Home,
  Building,
  FileText,
  Users,
  Building2,
  Cog,
  CreditCard,
  LifeBuoy,
  ShieldCheck,
  UserRound,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { Permissions } from './permissions';

export interface RouteAccessRule {
  requiredRoles?: string[];
  requiredPermission?: string;
  requiredAnyPermission?: string[];
  superAdminOnly?: boolean;
}

/**
 * Single source of truth for route/menu access rules.
 * Use these in both App router guards and sidebar navigation items.
 */
export const routeAccess = {
  templates: { requiredPermission: Permissions.TemplatesRead } as RouteAccessRule,
  myOrganization: {
    requiredAnyPermission: [Permissions.MyOrgRead, Permissions.MyOrgUpdate],
  } as RouteAccessRule,
  adminOnly: { superAdminOnly: true } as RouteAccessRule,
} as const;

export interface NavigationItem {
  title: string;
  url: string;
  icon: LucideIcon;
  /** Permission required to see this item (optional - visible to all if not set) */
  requiredPermission?: string;
  /** Any of these permissions grant access (optional) */
  requiredAnyPermission?: string[];
  /** Only show to super admin users */
  superAdminOnly?: boolean;
}

export const navigationItems: NavigationItem[] = [
  { title: 'Dashboard', url: '/', icon: Home },
  {
    title: 'Property List',
    url: '/properties',
    icon: Building,
    requiredPermission: Permissions.PropertiesRead,
  },
  { title: 'Templates', url: '/templates', icon: FileText, ...routeAccess.templates },
  {
    title: 'Organizations',
    url: '/admin/organizations',
    icon: Building2,
    ...routeAccess.adminOnly,
  },
  {
    title: 'Mobile Config',
    url: '/admin/mobile-config',
    icon: Cog,
    ...routeAccess.adminOnly,
  },
  {
    title: 'Schemas',
    url: '/admin/schemas',
    icon: Cog,
    ...routeAccess.adminOnly,
  },
  {
    title: 'Subscriptions',
    url: '/admin/subscriptions',
    icon: CreditCard,
    ...routeAccess.adminOnly,
  },
  {
    title: 'Business Users',
    url: '/admin/users',
    icon: Users,
    ...routeAccess.adminOnly,
  },
  {
    title: 'Home Owners',
    url: '/admin/homeowners',
    icon: UserRound,
    ...routeAccess.adminOnly,
  },
  {
    title: 'Business Users Pool',
    url: '/admin/business-users-pool',
    icon: Users,
    ...routeAccess.adminOnly,
  },
  {
    title: 'Homeowner Users Pool',
    url: '/admin/homeowner-users-pool',
    icon: UserRound,
    ...routeAccess.adminOnly,
  },
  {
    title: 'Support',
    url: '/admin/support',
    icon: LifeBuoy,
    ...routeAccess.adminOnly,
  },
  {
    title: 'Account Recovery',
    url: '/admin/recovery-cases',
    icon: ShieldCheck,
    ...routeAccess.adminOnly,
  },
];
